module.exports = __webpack_public_path__ + "img/gertrude.efa8905d.png";